module.exports = __webpack_public_path__ + "static/media/0520-r-r-en.3aa06718.png";